import type React from 'react';

import { BannerStateContainer } from '@confluence/banners/entry-points/BannerStateContainer.ts';
import { token } from '@atlaskit/tokens';
import { fg } from '@confluence/feature-gating';

const OBJECT_SIDEBAR_PANEL_WIDTH = 400;
const VERSION_HISTORY_SIDE_PANEL_WIDTH = 320;

const calculateIframeWidth = (isSidebarPanelOpen: boolean, isVersionHistoryOpen: boolean) => {
	// When the ADS Panel System is active, the object sidebar (commentsPanel, detailsPanel)
	// is rendered in the ADS navigation-system Panel slot outside the database iframe,
	// which already narrows the iframe via flex layout. The iframe must NOT manually subtract
	// the panel width — doing so would double-shrink it (e.g. 804px → 404px → 4px).
	if (isSidebarPanelOpen && !fg('ads-panel-system-confluence-object-sidebar')) {
		return `calc(100% - ${OBJECT_SIDEBAR_PANEL_WIDTH}px)`;
	}
	if (isVersionHistoryOpen) {
		return `calc(100% - ${VERSION_HISTORY_SIDE_PANEL_WIDTH}px)`;
	}
	return '100%';
};

export const databaseHeightContainer: (typeof BannerStateContainer)[] = [BannerStateContainer];
export const databaseShellStyle = (
	topNavAndBannerHeight: number,
	isVersionHistoryOpen: boolean = false,
	isObjectSidebarShown: boolean = false,
): React.CSSProperties => ({
	width: calculateIframeWidth(isObjectSidebarShown, isVersionHistoryOpen),
	height: topNavAndBannerHeight > 0 ? `calc(100vh - ${topNavAndBannerHeight}px)` : '100vh',
	display: 'block',
	border: fg('confluence_frontend_tokenize_border') ? token('space.0') : '0px',
	...(isVersionHistoryOpen || isObjectSidebarShown
		? { transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1) 0s' }
		: {}),
});
